// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.toast__GMqga {
  display: flex;
  width: 100%;
  align-self: center;
  padding: 0;
  justify-content: space-between;
  border-radius: 0;
  border: none;
  height: auto;
  min-height: unset;
  margin-bottom: 10px;
}

.toastBody__Ptj6z {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 15px;
  min-height: 46px;
}

.toastContent__Zwm9v {
  display: flex;
  align-items: center;
}

.toastSuccess__FjFQM {
  border: 1px solid var(--notifications-success-stroke);
  border-left: 4px solid var(--notifications-success-stroke);
  background: var(--notifications-success-surface);
  color: var(--notifications-success-text);
}

.toastInfo__E_uxM {
  background: var(--notifications-info-surface);
  border: 1px solid var(--notifications-info-stroke);
  border-left: 5px solid var(--notifications-info-stroke);
  color: var(--notifications-info-text);
}

.toastError__MASTF {
  background: var(--notifications-error-surface);
  border: 1px solid var(--notifications-error-stroke);
  border-left: 5px solid var(--notifications-error-stroke);
  color: var(--notifications-error-text);
}

.toastIcon__MG8fc {
  margin-right: 15px;
}

.toastMessage__qCNVS {
  font-size: 14px;
  width: 100%;
  text-align: 14px;
  margin: 0;
}

.toastCloseButton__k5W3U {
  width: 16px;
  height: 16px;
}`, "",{"version":3,"sources":["webpack://./../src/components/common/Toast/style.module.scss"],"names":[],"mappings":"AA0EA;EACE,aAAA;EACA,WAAA;EACA,kBAAA;EACA,UAAA;EACA,8BAAA;EACA,gBAAA;EACA,YAAA;EACA,YAAA;EACA,iBAAA;EACA,mBAAA;AAzEF;;AA4EA;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,kBAAA;EACA,gBAAA;AAzEF;;AA4EA;EACE,aAAA;EACA,mBAAA;AAzEF;;AA4EA;EACE,qDAAA;EACA,0DAAA;EACA,gDAAA;EACA,wCAAA;AAzEF;;AA4EA;EACE,6CAAA;EACA,kDAAA;EACA,uDAAA;EACA,qCAAA;AAzEF;;AA4EA;EACE,8CAAA;EACA,mDAAA;EACA,wDAAA;EACA,sCAAA;AAzEF;;AA4EA;EACE,kBAAA;AAzEF;;AA4EA;EACE,eAAA;EACA,WAAA;EACA,gBAAA;EACA,SAAA;AAzEF;;AA4EA;EACE,WAAA;EACA,YAAA;AAzEF","sourcesContent":["%scrollbar-style {\n  scrollbar-color: rgba(0, 0, 0, 0.2) rgba(0, 0, 0, 0.05);\n  scrollbar-width: auto;\n\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n@mixin scrollBar {\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n\n@mixin ellipsis-text {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: pre-wrap;\n  word-wrap: break-word;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n}\n\n@mixin tooltip {\n  padding: 8px !important;\n  opacity: 1 !important;\n  filter: drop-shadow(0 0 1px rgba(12, 26, 75, 0.24));\n  border-radius: 4px !important;\n  text-align: left !important;\n}\n\n@mixin modalTitle {\n  color: var(--header-title-main);\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 20px;\n  text-transform: uppercase;\n}\n\n.toast {\n  display: flex;\n  width: 100%;\n  align-self: center;\n  padding: 0;\n  justify-content: space-between;\n  border-radius: 0;\n  border: none;\n  height: auto;\n  min-height: unset;\n  margin-bottom: 10px;\n}\n\n.toastBody {\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 10px 15px;\n  min-height: 46px;\n}\n\n.toastContent {\n  display: flex;\n  align-items: center;\n}\n\n.toastSuccess {\n  border: 1px solid var(--notifications-success-stroke);\n  border-left: 4px solid var(--notifications-success-stroke);\n  background: var(--notifications-success-surface);\n  color: var(--notifications-success-text);\n}\n\n.toastInfo {\n  background: var(--notifications-info-surface);\n  border: 1px solid var(--notifications-info-stroke);\n  border-left: 5px solid var(--notifications-info-stroke);\n  color: var(--notifications-info-text);\n}\n\n.toastError {\n  background: var(--notifications-error-surface);\n  border: 1px solid var(--notifications-error-stroke);\n  border-left: 5px solid var(--notifications-error-stroke);\n  color: var(--notifications-error-text);\n}\n\n.toastIcon {\n  margin-right: 15px;\n}\n\n.toastMessage {\n  font-size: 14px;\n  width: 100%;\n  text-align: 14px;\n  margin: 0;\n}\n\n.toastCloseButton {\n  width: 16px;\n  height: 16px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"toast": `toast__GMqga`,
	"toastBody": `toastBody__Ptj6z`,
	"toastContent": `toastContent__Zwm9v`,
	"toastSuccess": `toastSuccess__FjFQM`,
	"toastInfo": `toastInfo__E_uxM`,
	"toastError": `toastError__MASTF`,
	"toastIcon": `toastIcon__MG8fc`,
	"toastMessage": `toastMessage__qCNVS`,
	"toastCloseButton": `toastCloseButton__k5W3U`
};
module.exports = ___CSS_LOADER_EXPORT___;
